import {
  Celebration,
  ChatBubbleOutlineOutlined,
  CommentOutlined,
  Favorite,
  RepeatOutlined,
  SendOutlined,
  ShortcutOutlined,
  ThumbUp,
  ThumbUpOffAltOutlined
} from '@mui/icons-material'
import { FC, ReactNode } from 'react'

import { GRAY_700 } from 'constants/styling/theme'
import { SocialNetwork } from 'models/socialCampaign'
import Typography from '@mui/material/Typography'
import emojiLike from 'assets/img/socialNetworks/reactions/emoji-like.svg'
import emojiLove from 'assets/img/socialNetworks/reactions/emoji-love.svg'
import styles from './PostPreviewCards.module.sass'
import { useTranslation } from 'react-i18next'

/*
 * Under a Facebook or LinkedIn card, the network's own reactions and action row, decorative as the rest of the card
 * (the counter is fixed). Facebook's like and love are v1's files; the rest are MUI icons drawn after each network.
 */

interface Action {
  key: string
  icon: ReactNode
}

const ACTIONS: { facebook: Action[], linkedin: Action[] } = {
  facebook: [
    { key: 'like', icon: <ThumbUpOffAltOutlined /> },
    { key: 'comment', icon: <ChatBubbleOutlineOutlined /> },
    { key: 'share', icon: <ShortcutOutlined /> },
  ],
  linkedin: [
    { key: 'like', icon: <ThumbUpOffAltOutlined /> },
    { key: 'comment', icon: <CommentOutlined /> },
    { key: 'repost', icon: <RepeatOutlined /> },
    { key: 'send', icon: <SendOutlined /> },
  ],
}

/** LinkedIn's like, celebrate and love, each a glyph on its coloured disc */
const LINKEDIN_REACTIONS = [
  { key: 'like', icon: <ThumbUp /> },
  { key: 'celebrate', icon: <Celebration /> },
  { key: 'love', icon: <Favorite /> },
]

/** The reactions with their count, then the action row: Facebook's or LinkedIn's (any other network reads as Facebook). */
export const FeedEngagement: FC<{ network: SocialNetwork }> = ({ network }) => {
  const { t } = useTranslation(['social_campaign'])
  const feed = network === SocialNetwork.LINKEDIN ? 'linkedin' : 'facebook'

  return (
    <>

      <div className={styles.reactions} aria-hidden="true">

        {feed === 'facebook' &&
          <span className={styles.emoji}>

            <img src={emojiLike} width={20} height={20} alt="" />

            <img src={emojiLove} width={20} height={20} alt="" />

          </span>
        }

        {feed === 'linkedin' &&
          <span className={styles.emoji}>
            {LINKEDIN_REACTIONS.map(({ key, icon }) => <span key={key} className={styles.reaction} data-reaction={key}>{icon}</span>)}
          </span>
        }

        <Typography variant="text-md" component="span" color={GRAY_700}>140</Typography>

      </div>

      <div className={styles.acts} aria-hidden="true">
        {ACTIONS[feed].map(({ key, icon }) => (
          <span key={key} className={styles.act}>

            {icon}

            <span className={styles.actLabel}>{t(`editor.preview.${feed}.${key}`)}</span>

          </span>
        ))}
      </div>

    </>
  )
}
